

export function sectionsHexagonsDate(props) {
  const date = {
    hexagonID: props.hexagonID,
    rotation_from: props.rotation_from,
    rotation_to: props.rotation_to,
    isVisible: true,
    color: props.color,
    icon: props.icon,
    opacity_from: 1,
    opacity_to: 1,
    filter_blur: 'blur(0px)',
    initial_scale: 1,
    gain_scale: 1,
    time_animation: '5s',
    interation_count: 'forwards',
    animation_enable: true,
  };

  return date;
}

export default sectionsHexagonsDate;



// WEBPACK FOOTER //
// ./src/components/UI/Animations/AnimationDate/sectionsHexagonsDate.jsx